/**
 * 指定した秒数でslickを切り替える
 * @param {*} $slide 
 * @param {*} $items 
 * @param {*} num 
 */
function slideScroll($slide,$items,num){
	var defaultWaitTime = 60; // 秒
	if($slide.length === 0 || $items.length === 0) return false;
	var $nowItems = $items.eq(num);
	var waitTime = $nowItems.attr('data-slide-item-time'); //切替までの時間
	if(!waitTime) waitTime = defaultWaitTime;
	//waitTime = waitTime * 200; // msに変換
	waitTime = waitTime * 1000; // msに変換
	setTimeout(function(){
		$slide.slick('slickNext'); //次へ
	},waitTime);
};

/**
 * セクション内にslideがあるときの設定
 * 表示された時にautoplay を 有効にする
 */
function innerSlideAction($sections,$slides,num){
	if($sections.length === 0 || $slides.length === 0) return false;
	var defaultWaitTime = 15; // 秒
	var $nowSection = $sections.eq(num);
	var $nowSectionInnerSlide = $nowSection.find('.js-inner-slide').eq(0);
	if($nowSectionInnerSlide.length !== 0){ //表示中
		$slides.slick('slickGoTo', 0, true); //スライド初期位置へ
		var waitTime = $nowSectionInnerSlide.attr('data-slide-time'); //切替までの時間
		if(!waitTime) waitTime = defaultWaitTime;
		waitTime = waitTime * 1000; // msに変換
		$slides.slick('slickSetOption', {
			autoplay:true,
			autoplaySpeed:waitTime
		},true);
	} else {
		$slides.slick('slickSetOption', 'autoplay', false,true);
		$slides.slick('slickGoTo', 0, true); //スライド初期位置へ
	}
}

/**
 * サイネージ切り替え
 */
!function(){
	var $slide = $('.js-section-rote');
	var $slideItem = $slide.find('.js-section-rote__item');
	var $innerSlide = $slideItem.find('.js-inner-slide');

	//ablogで出力されるhrを削除
	$slide.find("hr").remove();
	 
	/**
	 * 【slick】サイネージのフェード切替設定
	 */
	$slide.slick({
		dots: false,
		fade:true,
		speed:1000,
		arrows:false,
	});
	/**
	 * 【slick】ニュース等 サイネージ内のスライド切替設定
	 */
	$innerSlide.slick({
		dots:true,
		speed:1000,
		arrows:false,
		autoplay:false
	});

	/**
	 * 画面ロード後の最初のスクロール
	 */
	$(window).on('load',function(){
		var slideNum = $slide.slick('slickCurrentSlide'); //現在のスライド番号取得
		innerSlideAction($slideItem,$innerSlide,slideNum); //セクション内のslide
		slideScroll($slide,$slideItem,slideNum); //サイネージ切替
	});
	
	/**
	 * サイネージ開始後のスクロール
	 */
	$slide.on('afterChange', function(event, slick, currentSlide){
		if(event.target !== $slide.get(0)) return false; //サイネージの切替のみ 中のスライドも読み取ってしまうため
		var slideNum = currentSlide; //現在のスライド番号取得
		innerSlideAction($slideItem,$innerSlide,slideNum); //セクション内のslide
		slideScroll($slide,$slideItem,slideNum); //サイネージ切替
	});

	/**
	 * キーボードの左右キーでスクロールs
	 */
	$(window).keydown(function(event) {
		if (event.key === "ArrowRight"){
			$slide.slick('slickNext');
		}
		if (event.key === "ArrowLeft"){
			$slide.slick('slickPrev');
		}
	});
}();

/*
function siteinfo(){
	var $head = $('#header');
	var $main = $('#main');
	var $foot = $('#footer');
	var y = window.pageYOffset;
	console.log('【座標】Header',y + $head.get(0).getBoundingClientRect().top);
	console.log('【座標】Main',  y + $main.get(0).getBoundingClientRect().top);
	console.log('【座標】Footer',y + $foot.get(0).getBoundingClientRect().top);
	console.log('【高さ】Header',$head.height());
	console.log('【高さ】Main',  $main.height());
	console.log('【高さ】Footer',$foot.height());
	console.log('【座標】Main + 【高さ】Main',y + $main.get(0).getBoundingClientRect().top + $main.height());
}
$(function(){
	siteinfo();
});
*/